import { FeatureFlag } from 'types/features';
import { InvoiceData } from 'types/invoices';
import { useIsFeatureEnabled } from './useFeatureFlags';

/**
 * A light green tint marking the amount fields an invoice shows in payment currency. Addressed by
 * the form kit's slots; it goes on a field's own `wrapperClassName` or on a wrapper around a group
 * of fields. It stays translucent so the tint layers over whatever background the field sits on,
 * and it skips read-only controls — a field you cannot edit is not reporting a currency mode.
 */
export const paymentCurrencyInputClassName = [
    '[&_[data-slot=input]:not([readonly])]:bg-success/8',
    '[&_[data-slot=textarea]:not([readonly])]:bg-success/8',
    '[&_[data-slot=input-group]]:bg-success/8',
].join(' ');

/**
 * Payment currency display mode is driven by `invoice.isDisplayedInPaymentCurrency` boolean,
 * which is set via a switch in the General tab (guarded by FF + currencies differ in BE).
 *
 * @returns isPaymentCurrencyMode - whether amounts are shown in payment currency
 * @returns displayCurrency - the currency code for labels
 * @returns isFFEnabled - whether the FF is on (for showing the switch in General tab)
 */
export const usePaymentCurrencyMode = (invoice: InvoiceData) => {
    const isFFEnabled = useIsFeatureEnabled(FeatureFlag.INVOICE_FIELDS_VALUES_IN_PAYMENT_CURRENCY);
    const isPaymentCurrencyMode = isFFEnabled && !!invoice.isDisplayedInPaymentCurrency;
    const displayCurrency = isPaymentCurrencyMode ? invoice.paymentCurrencyTypeCode : invoice.invoiceCurrencyTypeCode;
    return { isPaymentCurrencyMode, displayCurrency, isFFEnabled };
};
